// extracted by mini-css-extract-plugin
export default {"sidebarHeading":"styles_sidebarHeading__TPHdX"};